import React, { PropsWithChildren, useMemo, useRef, useState } from 'react'

import useMediaQuery from 'src/hooks/useMediaQuery'

type TruncatedProps = PropsWithChildren<{
  className?: string
  moreText?: string
  lessText?: string
}>

export const Truncated = ({
  children,
  className,
  moreText = 'Read more...',
  lessText = 'Read less'
}: TruncatedProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const [expanded, setExpanded] = useState(false)

  const paragraph = useRef<HTMLParagraphElement | null>(null)

  const showExpandCollapse = useMemo(() => {
    if (!paragraph.current) return false

    if (
      paragraph.current.offsetWidth < paragraph.current.scrollWidth ||
      paragraph.current.offsetHeight < paragraph.current.scrollHeight
    ) {
      return true
    }
    return false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paragraph.current, children, isMobile])

  const handleReadMore = () => {
    setExpanded(v => !v)
    setTimeout(() => {
      paragraph.current?.scrollIntoView({
        block: !expanded ? 'nearest' : 'center',
        behavior: 'smooth'
      })
    }, 80)
  }

  const MoreLink = () => {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <span
        className='cursor-pointer text-sm text-primary font-bold'
        onClick={handleReadMore}
      >
        {expanded ? lessText : moreText}
      </span>
    )
  }

  return (
    <>
      <div
        ref={paragraph}
        className={`overflow-hidden
          ${
            // eslint-disable-next-line no-nested-ternary
            expanded ? '' : isMobile ? 'line-clamp-5' : 'line-clamp-13'
          } ${className}`}
      >
        {children}
      </div>
      {showExpandCollapse ? <MoreLink /> : null}
    </>
  )
}
